// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `

/* Tree Styling */

.genealogy-scroll::-webkit-scrollbar {
    width: 5px;
    height: 20px;
}

.genealogy-scroll::-webkit-scrollbar-track {
    border-radius: 10px;
    background-color: #e4e4e4;
}

.genealogy-scroll::-webkit-scrollbar-thumb {
    background: #212121;
    border-radius: 10px;
    -webkit-transition: 0.5s;
    transition: 0.5s;
}

.genealogy-scroll::-webkit-scrollbar-thumb:hover {
    background: #d5b14c;
    -webkit-transition: 0.5s;
    transition: 0.5s;
}

.genealogy-body {
    cursor: pointer;
    white-space: nowrap;
    overflow-x: auto;
    /*text-align: center;*/
}

.genealogy-tree {
    /* margin-top: 4rem; */
    display: inline-block;
    position: relative;
    z-index: 1;
}

.genealogy-tree ul {
    padding-top: 20px;
    position: relative;
    padding-left: 0px;
    display: flex;
    justify-content: center;
}

.genealogy-tree li {
    float: left;
    text-align: center;
    list-style-type: none;
    position: relative;
    padding: 20px 5px 0 5px;
}

.genealogy-tree li::before,
.genealogy-tree li::after {
    content: "";
    position: absolute;
    top: 0;
    right: 50%;
    border-top: 3px solid #d5b14c;
    width: 50%;
    height: 20px;
}

.genealogy-tree li::after {
    right: auto;
    left: 50%;
    border-left: 3px solid #d5b14c;
}

.genealogy-tree li:only-child::after,
.genealogy-tree li:only-child::before {
    display: none;
}

.genealogy-tree li:only-child {
    padding-top: 0;
}

.genealogy-tree li:first-child::before,
.genealogy-tree li:last-child::after {
    border: 0 none;
}

.genealogy-tree li:last-child::before {
    border-right: 3px solid #d5b14c;
    border-radius: 0 5px 0 0;
    -webkit-border-radius: 0 5px 0 0;
    -moz-border-radius: 0 5px 0 0;
}

.genealogy-tree li:first-child::after {
    border-radius: 5px 0 0 0;
    -webkit-border-radius: 5px 0 0 0;
    -moz-border-radius: 5px 0 0 0;
}

.genealogy-tree ul ul::before {
    content: "";
    position: absolute;
    top: -10px;
    left: 50%;
    border-left: 3px solid #d5b14c;
    width: 0;
    height: 30px;
}

.genealogy-tree li a {
    text-decoration: none;
    color: #666;
    font-family: arial, verdana, tahoma, serif;
    font-size: 11px;
    display: inline-block;
    border-radius: 5px;
    -webkit-border-radius: 5px;
    -moz-border-radius: 5px;
}






/* Single Video */

.tooltips {
    position: relative;
    display: inline-block;
}

.tooltips .tooltiptext {
    visibility: hidden;
    text-align: center;
    border-radius: 6px;
    padding: 5px 0;
    left: 137px;
    position: absolute;
    top: -168px;
    height: 257px;
    z-index: 1200;
    color: white;
}

.member-view-box {
    text-align: center;
    border-radius: 2px;
    position: relative;
}

.member-image {
    /* width: 100px; */
    position: relative;
    z-index: 10;
    /*width: 150px;*/
    width: 100px;
}

.member-image img {
    /*height: 73px;*/
    height: 50px;
    background-color: #000;
    z-index: 1;
    border: 1px solid black;
    width: 100%;
    border-radius: 3px 3px 0px 0px;
    object-fit: fill;
}

.child-name {
    background: #e6e6e6;
    color: black;
    font-size: 12px;
    margin: 0 auto;
    border-radius: 0px 0px 3px 3px;
    border: 1px solid #9a9a9a;
    padding: 0 2px;
    /*white-space: initial;*/
    word-break: break-word;
    line-height: 1.5;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}
`, "",{"version":3,"sources":["webpack://./src/app/layout/collab-tree-node/collab-tree-node.component.css"],"names":[],"mappings":";;AAEA,iBAAiB;;AAEjB;IACI,UAAU;IACV,YAAY;AAChB;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;IACnB,wBAAgB;IAAhB,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,wBAAgB;IAAhB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,mBAAmB;IACnB,gBAAgB;IAChB,sBAAsB;AAC1B;;AAEA;IACI,sBAAsB;IACtB,qBAAqB;IACrB,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,iBAAiB;IACjB,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,qBAAqB;IACrB,kBAAkB;IAClB,uBAAuB;AAC3B;;AAEA;;IAEI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,UAAU;IACV,6BAA6B;IAC7B,UAAU;IACV,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,SAAS;IACT,8BAA8B;AAClC;;AAEA;;IAEI,aAAa;AACjB;;AAEA;IACI,cAAc;AAClB;;AAEA;;IAEI,cAAc;AAClB;;AAEA;IACI,+BAA+B;IAC/B,wBAAwB;IACxB,gCAAgC;IAChC,6BAA6B;AACjC;;AAEA;IACI,wBAAwB;IACxB,gCAAgC;IAChC,6BAA6B;AACjC;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,SAAS;IACT,8BAA8B;IAC9B,QAAQ;IACR,YAAY;AAChB;;AAEA;IACI,qBAAqB;IACrB,WAAW;IACX,0CAA0C;IAC1C,eAAe;IACf,qBAAqB;IACrB,kBAAkB;IAClB,0BAA0B;IAC1B,uBAAuB;AAC3B;;;;;;;AAOA,iBAAiB;;AAEjB;IACI,kBAAkB;IAClB,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;IAClB,cAAc;IACd,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,aAAa;IACb,aAAa;IACb,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,WAAW;IACX,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,sBAAsB;IACtB,UAAU;IACV,uBAAuB;IACvB,WAAW;IACX,8BAA8B;IAC9B,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,eAAe;IACf,cAAc;IACd,8BAA8B;IAC9B,yBAAyB;IACzB,cAAc;IACd,wBAAwB;IACxB,sBAAsB;IACtB,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;IACnB,uBAAuB;AAC3B","sourcesContent":["\n\n/* Tree Styling */\n\n.genealogy-scroll::-webkit-scrollbar {\n    width: 5px;\n    height: 20px;\n}\n\n.genealogy-scroll::-webkit-scrollbar-track {\n    border-radius: 10px;\n    background-color: #e4e4e4;\n}\n\n.genealogy-scroll::-webkit-scrollbar-thumb {\n    background: #212121;\n    border-radius: 10px;\n    transition: 0.5s;\n}\n\n.genealogy-scroll::-webkit-scrollbar-thumb:hover {\n    background: #d5b14c;\n    transition: 0.5s;\n}\n\n.genealogy-body {\n    cursor: pointer;\n    white-space: nowrap;\n    overflow-x: auto;\n    /*text-align: center;*/\n}\n\n.genealogy-tree {\n    /* margin-top: 4rem; */\n    display: inline-block;\n    position: relative;\n    z-index: 1;\n}\n\n.genealogy-tree ul {\n    padding-top: 20px;\n    position: relative;\n    padding-left: 0px;\n    display: flex;\n    justify-content: center;\n}\n\n.genealogy-tree li {\n    float: left;\n    text-align: center;\n    list-style-type: none;\n    position: relative;\n    padding: 20px 5px 0 5px;\n}\n\n.genealogy-tree li::before,\n.genealogy-tree li::after {\n    content: \"\";\n    position: absolute;\n    top: 0;\n    right: 50%;\n    border-top: 3px solid #d5b14c;\n    width: 50%;\n    height: 20px;\n}\n\n.genealogy-tree li::after {\n    right: auto;\n    left: 50%;\n    border-left: 3px solid #d5b14c;\n}\n\n.genealogy-tree li:only-child::after,\n.genealogy-tree li:only-child::before {\n    display: none;\n}\n\n.genealogy-tree li:only-child {\n    padding-top: 0;\n}\n\n.genealogy-tree li:first-child::before,\n.genealogy-tree li:last-child::after {\n    border: 0 none;\n}\n\n.genealogy-tree li:last-child::before {\n    border-right: 3px solid #d5b14c;\n    border-radius: 0 5px 0 0;\n    -webkit-border-radius: 0 5px 0 0;\n    -moz-border-radius: 0 5px 0 0;\n}\n\n.genealogy-tree li:first-child::after {\n    border-radius: 5px 0 0 0;\n    -webkit-border-radius: 5px 0 0 0;\n    -moz-border-radius: 5px 0 0 0;\n}\n\n.genealogy-tree ul ul::before {\n    content: \"\";\n    position: absolute;\n    top: -10px;\n    left: 50%;\n    border-left: 3px solid #d5b14c;\n    width: 0;\n    height: 30px;\n}\n\n.genealogy-tree li a {\n    text-decoration: none;\n    color: #666;\n    font-family: arial, verdana, tahoma, serif;\n    font-size: 11px;\n    display: inline-block;\n    border-radius: 5px;\n    -webkit-border-radius: 5px;\n    -moz-border-radius: 5px;\n}\n\n\n\n\n\n\n/* Single Video */\n\n.tooltips {\n    position: relative;\n    display: inline-block;\n}\n\n.tooltips .tooltiptext {\n    visibility: hidden;\n    text-align: center;\n    border-radius: 6px;\n    padding: 5px 0;\n    left: 137px;\n    position: absolute;\n    top: -168px;\n    height: 257px;\n    z-index: 1200;\n    color: white;\n}\n\n.member-view-box {\n    text-align: center;\n    border-radius: 2px;\n    position: relative;\n}\n\n.member-image {\n    /* width: 100px; */\n    position: relative;\n    z-index: 10;\n    /*width: 150px;*/\n    width: 100px;\n}\n\n.member-image img {\n    /*height: 73px;*/\n    height: 50px;\n    background-color: #000;\n    z-index: 1;\n    border: 1px solid black;\n    width: 100%;\n    border-radius: 3px 3px 0px 0px;\n    object-fit: fill;\n}\n\n.child-name {\n    background: #e6e6e6;\n    color: black;\n    font-size: 12px;\n    margin: 0 auto;\n    border-radius: 0px 0px 3px 3px;\n    border: 1px solid #9a9a9a;\n    padding: 0 2px;\n    /*white-space: initial;*/\n    word-break: break-word;\n    line-height: 1.5;\n    overflow: hidden;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
